import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { toast } from "sonner";
import { LockKey, Folders } from "@phosphor-icons/react";
import { MiscRecordPage } from "./MiscRecordPage";

const STORAGE_KEY = "pi2_passcode"; // shared unlock with Purchase INV 2 / Bank Statement

export default function Others() {
  const [passcode, setPasscode] = useState(() => sessionStorage.getItem(STORAGE_KEY) || "");
  const [input, setInput] = useState("");
  const [locked, setLocked] = useState(!sessionStorage.getItem(STORAGE_KEY));

  useEffect(() => {
    if (passcode) { sessionStorage.setItem(STORAGE_KEY, passcode); setLocked(false); }
  }, [passcode]);

  const submit = async (e) => {
    e?.preventDefault();
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/misc-records/others`, {
        headers: {
          "X-Passcode": input,
          Authorization: `Bearer ${localStorage.getItem("access_token") || ""}`,
        },
      });
      if (res.status === 403) { toast.error("Wrong passcode"); return; }
      setPasscode(input);
    } catch { toast.error("Could not verify passcode"); }
  };

  const relock = () => { sessionStorage.removeItem(STORAGE_KEY); setPasscode(""); setInput(""); setLocked(true); };

  if (locked || !passcode) {
    return (
      <Layout>
        <div className="max-w-md mx-auto mt-20 bg-white border border-zinc-200 p-8" data-testid="others-passcode-gate">
          <div className="flex items-center gap-2 mb-4">
            <LockKey size={22} weight="duotone" className="text-[#002FA7]"/>
            <div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 font-mono">Restricted</div>
              <div className="font-display font-black text-2xl text-zinc-950">Others</div>
            </div>
          </div>
          <p className="text-sm text-zinc-500 mb-4">This register is passcode-protected. Enter the passcode to view or add records.</p>
          <form onSubmit={submit} className="space-y-3">
            <input type="password" value={input} onChange={e=>setInput(e.target.value)}
              placeholder="Passcode" autoFocus data-testid="others-passcode-input"
              className="w-full font-mono text-sm border border-zinc-200 px-3 py-2 focus:outline-none focus:border-[#002FA7]"/>
            <button type="submit" data-testid="others-passcode-submit"
              className="w-full bg-[#002FA7] text-white text-sm px-4 py-2 hover:bg-[#00227A]">Unlock</button>
          </form>
        </div>
      </Layout>
    );
  }

  return (
    <div className="relative">
      <MiscRecordPage
        variant="others"
        kicker="Restricted"
        title="Others"
        subtitle="Miscellaneous restricted records. Same passcode as Purchase INV 2 / Bank Statement."
        extraHeaders={{ "X-Passcode": passcode }}
        passcodeQuery={passcode}
        testIdPrefix="others"
        Icon={Folders}
      />
      <button onClick={relock} data-testid="others-relock" className="fixed bottom-4 right-4 bg-white border border-zinc-200 text-xs px-3 py-2 shadow-lg hover:bg-zinc-50 flex items-center gap-1">
        <LockKey size={12}/> Re-lock
      </button>
    </div>
  );
}
